/**
 * Loyal Review — Guía del administrador (Español)
 */

export default `# Loyal Review — Guía del administrador

## ¿Qué es Loyal Review?

Loyal Review es una ruta positiva alternativa dentro de Review
Shield. Los clientes que califican la experiencia por encima del
Umbral de reseña pública ven una pantalla de elección amable:

- **Recibir un regalo de nuestra parte** — se envía un cupón por
  correo al cliente y puede canjearse en su próxima visita.
- **Continuar para dejar una reseña pública** — el flujo actual de
  Google, sin cambios.

Loyal Review reutiliza la interfaz de Review Shield, el motor de
bonos y el flujo de correos existentes. No hay un flujo de bonos
separado, ni un panel de administración nuevo, ni un informe
adicional.

---

## Flujo del comerciante

### 1. Crear un bono (flujo existente)
Vaya a **Bonos → Asignar**. Añada destinatarios, valores y método
de entrega exactamente como hoy.

### 2. Marque el bono como «Disponible para Loyal Review»
Antes de hacer clic en **Añadir a la lista**, marque la nueva
casilla «Disponible para Loyal Review». Esto convierte el bono en
una *plantilla de recompensa* que el flujo de Review Shield puede
clonar. La plantilla nunca se canjea — existe para que usted pueda
revisarla, editarla o archivarla desde la lista estándar de Bonos.

### 3. Active Loyal Review en la tarjeta
Vaya a **Tarjetas → Ajustes de la tarjeta → Review Shield**. Debajo
del Umbral de reseña pública verá un nuevo control **Experiencia
positiva** con dos opciones: Estándar o Loyal Review.

- Elija **Estándar** para conservar el comportamiento actual (los
  clientes positivos van directamente al flujo de reseña pública).
- Elija **Loyal Review** y seleccione una recompensa en el menú
  desplegable. Solo aparecen los bonos marcados como «Disponible
  para Loyal Review».

### 4. Guarde

La tarjeta cambia inmediatamente al flujo Loyal Review la próxima
vez que un cliente la escanee y otorgue una calificación igual o
superior al umbral.

---

## Experiencia del cliente

1. El cliente escanea la tarjeta y califica la experiencia.
2. Si la calificación es **igual o superior** al Umbral de reseña
   pública Y Loyal Review está activo, el cliente ve la pantalla
   de elección.
3. Si elige **Recibir un regalo**, entonces:
   - ingresa su correo;
   - lee y acepta los Términos y Condiciones del cupón (obligatorio);
   - recibe su cupón en pantalla y por correo;
   - a continuación se le invita amablemente a dejar una reseña
     pública.
4. Si elige **Continuar para dejar una reseña pública**, el flujo
   es idéntico al comportamiento Estándar actual.

El cliente nunca ve la marca «Loyal Review». Ve copia hospitalaria:
«Elija una opción: Recibir un regalo de nuestra parte · Continuar
para dejar una reseña pública».

---

## Regla de visita de regreso

Cada bono emitido a través de Loyal Review lleva un
\`redeemable_from\` correspondiente al **inicio del SIGUIENTE día
calendario en la zona horaria local de la organización**. El
personal que intente canjear un bono Loyal Review el mismo día de
la emisión verá el mensaje de rechazo \`NOT_YET_REDEEMABLE\`.

Los bonos emitidos manualmente **no se ven afectados** — pueden
canjearse inmediatamente. La regla de visita de regreso se aplica
únicamente a las emisiones de Loyal Review.

---

## Umbral de reseña pública — una sola configuración, dos rutas

El Umbral de reseña pública que ya configuró para Review Shield es
la *única fuente de verdad*. Loyal Review lo hereda
automáticamente. No hay un umbral separado ni una configuración
duplicada, ni riesgo de que ambos flujos difieran.

---

## Términos y Condiciones del cupón

Antes de que se pueda emitir un bono Loyal Review, el cliente DEBE
aceptar explícitamente los Términos y Condiciones del cupón en la
pantalla del correo. La aceptación se registra con:

- Marca temporal
- Idioma mostrado (es / en / fr)
- Versión de los términos (\`v1.0\` en el lanzamiento)
- Fuente = \`LR\`

Si la casilla no se marca:

- No se emite ningún bono.
- No se envía ningún correo.
- No se guarda nada más allá del registro de auditoría de la
  solicitud.

---

## Correo de recordatorio

Si el cliente no ha canjeado su bono a la mitad de su vida útil,
se envía un correo de recordatorio automático — exactamente una
vez — a través del flujo Resend existente.

---

## Notas para el personal de soporte

- Los bonos emitidos a través de Loyal Review muestran la fuente
  **LR** en los informes y la auditoría de bonos. Filtre por esta
  fuente para contar las emisiones de Loyal Review.
- Si un cliente informa «el bono no se puede canjear el día que lo
  recibí», confirme la regla de visita de regreso anterior — es
  por diseño.
- Si un comerciante pregunta «cómo desactivar Loyal Review», puede
  volver a poner la tarjeta en **Estándar** en los ajustes o
  archivar / desactivar el bono de recompensa (ambos detienen las
  nuevas emisiones).
`;
